const TAB_KEY = 9;

export function isTab (e) {
    const key = e.keyCode || e.which;

    return {tab: key === TAB_KEY, shiftKey: e.shiftKey};
}